import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import FanEngagementTypeComponent from "../../Components/FanEngagementTypeComponent/FanEngagementTypeComponent";

const FanEngagementType = () => {
  return (
    <div>
      <Header />
      <FanEngagementTypeComponent />
      <Footer />
    </div>
  );
};

export default FanEngagementType;  